

























































import { Component, Vue, Prop } from 'vue-property-decorator';

import CheckIcon from '@/components/icons/Check.vue';
import {
  EOfferTypeEnum,
  IOfferDiscountTypeName,
  SpecialOfferTypeEnum
} from '@/models/offer';
import TagSpecialCoin from '@/componentsV2/atoms/TagSpecialCoin/TagSpecialCoin.vue';
import TagBirthday from '@/components/organisms/Offers/DataPresentation/TagBirthday.vue';
import { formatMoney } from '@/utils/moneyFormarter';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: {
    Typography,
    CheckIcon,
    TagSpecialCoin,
    TagBirthday
  }
})
export default class OfferTypeTag extends Vue {
  @Prop() offer!: any;
  @Prop() hideValues!: boolean;

  SpecialOfferTypeEnum = SpecialOfferTypeEnum;

  get mapper() {
    return {
      [SpecialOfferTypeEnum.TWO_FOR_ONE]: '2 for 1',
      [SpecialOfferTypeEnum.PRODUCT_AND_SERVICE]: 'Specific discount',
      [SpecialOfferTypeEnum.BIRTHDAY]: 'Birthday offer',
      [SpecialOfferTypeEnum.STOREWIDE]: 'General offer',
      [SpecialOfferTypeEnum.HAPPY_HOUR]: '🎉 Happy Hour'
    };
  }

  get country() {
    return this.$store.getters['internationalization/getCountrySettings'];
  }

  get isBirthday() {
    return this.offer.specialType === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get specialType() {
    if (this.offer.type === EOfferTypeEnum.HAPPY_HOUR) {
      return SpecialOfferTypeEnum.HAPPY_HOUR;
    }
    return this.offer.specialType;
  }

  get specialTypeText() {
    return this.mapper[this.specialType as SpecialOfferTypeEnum];
  }

  getFormatedDiscount(
    typeDiscount: string,
    value: string,
    isDiscount?: boolean
  ) {
    if (value === 'Free') return value;
    else if (!value) return 'Price Here';

    if (typeDiscount === IOfferDiscountTypeName.PERCENTAGE) {
      return `${value}% OFF`;
    }
    return `${formatMoney(
      {
        lang: this.country.langCode,
        currency: this.country.currency
      },
      String(value).replace(/[^0-9.-]+/g, '')
    )} ${isDiscount ? 'OFF' : ''}`;
  }

  calcDiscount(
    typeDiscount: string,
    valueOfferStr: string,
    valueDiscountStr: string
  ) {
    let res: number;
    const valueOffer: number = Number(
      String(valueOfferStr).replace(/[^0-9.-]+/g, '')
    );
    const valueDiscount: number = Number(
      String(valueDiscountStr).replace(/[^0-9.-]+/g, '')
    );

    if (typeDiscount === IOfferDiscountTypeName.PERCENTAGE) {
      res = valueOffer - (valueOffer * valueDiscount) / 100;
    } else {
      res = valueOffer - valueDiscount;
    }
    return res > 0 ? res.toFixed(2) : 'Free';
  }
}
